import React from 'react';
import { useT, i18n } from '../services/i18n';
import FaqSection from './FaqSection';
import { useHomeContent } from '../services/homeContent';

const HomeFaq = () => {
  const { t } = useT();
  const content = useHomeContent(i18n.get());
  const items = content?.faq?.items || [1, 2, 3, 4, 5, 6].map((n) => ({ question: t(`home.faq${n}q`), answer: t(`home.faq${n}a`) }));
  return (
    <section className="bg-gray-50 py-6 sm:py-10" data-testid="home-faq-wrap">
      <div className="max-w-7xl mx-auto px-4">
        <FaqSection items={items} title={content?.faq?.title || t('home.faqTitle')} testId="home-faq" />
      </div>
    </section>
  );
};

export default HomeFaq;
